import React, { useContext } from 'react';
import { CheckoutContext, CheckoutContextProps } from '../../../context/CheckoutContext';
import { SkeletonWrapper } from './style';

interface SkeletonContentLoaderProps {
  isLoading: boolean;
  skeleton: React.ReactNode;
  children: React.ReactNode;
  isEmptyState?: boolean;
  emptyState?: React.ReactNode;
}

const SkeletonContentLoader: React.FC<SkeletonContentLoaderProps> = ({ 
  isLoading, 
  skeleton, 
  children,
  isEmptyState = false,
  emptyState,
}) => {
  const { isLoadingCompany } = useContext(CheckoutContext) as CheckoutContextProps;
  
  const shouldShowSkeleton = isLoading || isLoadingCompany;

  if (shouldShowSkeleton) {
    return (
      <SkeletonWrapper data-testid="skeleton-content-loader">
        {skeleton}
      </SkeletonWrapper>
    );
  }

  if (isEmptyState && emptyState) {
    return (
      <SkeletonWrapper data-testid="empty-state-content-loader">
        {emptyState}
      </SkeletonWrapper>
    );
  }

  return <>{children}</>;
};

export default SkeletonContentLoader;

